import { useTranslation } from "react-i18next";
import { Button, Stack, Typography } from "@schaeffler-commerce/design-system";
import { formatAsmTimer } from "~/features/assistedService/utils/asmTimer";

interface Props {
  remainingSeconds: number;
  onReset: () => void;
  className?: string;
  sx?: object;
}

/** ASM agent-session countdown driven by the agent-token expiry. At 0 the hook fires the F50 logout; the reset button silently renews via the rotating refresh token. */
export const AsmTimer = ({ remainingSeconds, onReset, className, sx }: Props) => {
  const { t } = useTranslation();
  return (
    <Stack
      className={className}
      direction="row"
      spacing={1}
      sx={[
        {
          alignItems: "center",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography variant="bodyMedium" component="span">
        {t("asm.emulate.timer")}
      </Typography>
      <Typography variant="bodyMedium" component="span">
        {formatAsmTimer(remainingSeconds)}
      </Typography>
      <Button variant="text" size="small" onClick={onReset} disabled={remainingSeconds <= 0}>
        {t("asm.emulate.reset")}
      </Button>
    </Stack>
  );
};
